var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChoach(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_Choach__Icn/40px/Choach",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_Choach__Color/Transp_00",
    opacity: 0
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H40V40H0z",
    id: ".._.._src_svg_Icn_40px_Choach__Rectangle"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M20,7 C22.6125579,7 24.8351204,8.66976896 25.6587023,11.0003218 L30,11 L30,13 L26,13 C26,16.3137085 23.3137085,19 20,19 C16.6862915,19 14,16.3137085 14,13 C14,9.6862915 16.6862915,7 20,7 Z M16,13 C16,15.209139 17.790861,17 20,17 C22.209139,17 24,15.209139 24,13 L16,13 Z M20,9 C18.519485,9 17.2268344,9.80434324 16.5351985,10.9998796 L23.4648015,10.9998796 C22.7731656,9.80434324 21.480515,9 20,9 Z M22,20 C25.8659932,20 29,23.1340068 29,27 L29,32 L11,32 L11,27 C11,23.1340068 14.1340068,20 18,20 L22,20 Z M24.1552322,22.4870647 L20,28.2001838 L15.8446595,22.4871166 C14.2235951,23.2627282 13.0855853,24.8860559 13.0046195,26.7831104 L13,27 L13,30 L27,30 L27,27 C27,25.0103057 25.8378064,23.2920563 24.1552322,22.4870647 Z M22,22 L18,22 L17.964,22.001 L19.999,24.799 L22.034,22.001 L22,22 Z",
    id: ".._.._src_svg_Icn_40px_Choach__Combined-Shape"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChoach);
export default __webpack_public_path__ + "static/media/Choach.70c9d5bb8fe987d62472d190b2e6422a.svg";
export { ForwardRef as ReactComponent };